module.exports = __webpack_public_path__ + "static/media/video_image.2e8ecccb.jpg";